var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQr = function SvgQr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 29,
    width: 36,
    height: 36,
    rx: 11.5,
    stroke: "#9CA3AF",
    strokeWidth: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 36,
    height: 36,
    rx: 11.5,
    stroke: "#9CA3AF",
    strokeWidth: 9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 114,
    width: 36,
    height: 36,
    rx: 11.5,
    stroke: "#9CA3AF",
    strokeWidth: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.5 138C172.015 138 170 140.015 170 142.5V144.5C170 158.583 158.583 170 144.5 170H143.5C141.015 170 139 172.015 139 174.5C139 176.985 141.015 179 143.5 179H144.5C163.554 179 179 163.554 179 144.5V142.5C179 140.015 176.985 138 174.5 138Z",
    fill: "#229ACE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 138C6.98528 138 9 140.015 9 142.5V144.5C9 158.583 20.4167 170 34.5 170H35.5C37.9853 170 40 172.015 40 174.5C40 176.985 37.9853 179 35.5 179H34.5C15.4462 179 0 163.554 0 144.5V142.5C0 140.015 2.01472 138 4.5 138Z",
    fill: "#229ACE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.5 41C172.015 41 170 38.9853 170 36.5V34.5C170 20.4167 158.583 9 144.5 9H143.5C141.015 9 139 6.98528 139 4.5C139 2.01472 141.015 0 143.5 0H144.5C163.554 0 179 15.4462 179 34.5V36.5C179 38.9853 176.985 41 174.5 41Z",
    fill: "#229ACE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 41C6.98528 41 9 38.9853 9 36.5V34.5C9 20.4167 20.4167 9 34.5 9H35.5C37.9853 9 40 6.98528 40 4.5C40 2.01472 37.9853 0 35.5 0H34.5C15.4462 0 0 15.4462 0 34.5V36.5C0 38.9853 2.01472 41 4.5 41Z",
    fill: "#229ACE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5 24.5H97.5C100.261 24.5 102.5 26.7386 102.5 29.5V60.5V69.5V71C102.5 73.4853 100.485 75.5 98 75.5H96.5C94.8431 75.5 93.5 74.1569 93.5 72.5C93.5 70.8431 92.1569 69.5 90.5 69.5H89C86.5147 69.5 84.5 67.4853 84.5 65C84.5 62.5147 86.5147 60.5 89 60.5C91.4853 60.5 93.5 58.4853 93.5 56V55.5C93.5 52.7386 91.2614 50.5 88.5 50.5H88C85.5147 50.5 83.5 48.4853 83.5 46C83.5 43.5147 85.5147 41.5 88 41.5H89.5C91.7091 41.5 93.5 39.7091 93.5 37.5C93.5 35.2909 91.7091 33.5 89.5 33.5H89C86.5147 33.5 84.5 31.4853 84.5 29C84.5 26.5147 86.5147 24.5 89 24.5H93.5ZM94.5 89C94.5 86.5147 96.5147 84.5 99 84.5C101.485 84.5 103.5 86.5147 103.5 89V98C103.5 100.485 101.485 102.5 99 102.5C96.5147 102.5 94.5 100.485 94.5 98V89ZM87 89.5C87 91.9853 84.9853 94 82.5 94H73.25C71.1789 94 69.5 95.6789 69.5 97.75C69.5 99.8211 67.8211 101.5 65.75 101.5H64.25C62.1789 101.5 60.5 99.8211 60.5 97.75C60.5 95.6789 58.8211 94 56.75 94H29C26.5147 94 24.5 91.9853 24.5 89.5C24.5 87.0147 26.5147 85 29 85H56.75C58.8211 85 60.5 83.3211 60.5 81.25C60.5 79.1789 62.1789 77.5 64.25 77.5H65.75C67.8211 77.5 69.5 79.1789 69.5 81.25C69.5 83.3211 71.1789 85 73.25 85H82.5C84.9853 85 87 87.0147 87 89.5ZM118.5 98.25C118.5 95.9028 120.403 94 122.75 94H133.5C139.851 94 145 99.1487 145 105.5V133C145 135.485 147.015 137.5 149.5 137.5C151.985 137.5 154 135.485 154 133V105.5C154 94.1782 144.822 85 133.5 85H122.5C120.153 85 118.25 86.9028 118.25 89.25C118.25 91.5972 116.347 93.5 114 93.5H113.875C111.459 93.5 109.5 95.4588 109.5 97.875V98C109.5 100.485 111.515 102.5 114 102.5H114.25C116.597 102.5 118.5 100.597 118.5 98.25ZM80.5 126.5C80.5 123.739 82.7386 121.5 85.5 121.5H89.5H94C96.4853 121.5 98.5 123.515 98.5 126C98.5 128.485 96.4853 130.5 94 130.5C91.5147 130.5 89.5 132.515 89.5 135V141C89.5 143.485 91.5147 145.5 94 145.5C96.4853 145.5 98.5 147.515 98.5 150C98.5 152.485 96.4853 154.5 94 154.5H89.5H85.5C82.7386 154.5 80.5 152.261 80.5 149.5V126.5ZM123 130.5C125.485 130.5 127.5 128.485 127.5 126C127.5 123.515 125.485 121.5 123 121.5H114C111.515 121.5 109.5 123.515 109.5 126C109.5 128.485 111.515 130.5 114 130.5H123ZM135.5 141.5C135.5 139.291 137.291 137.5 139.5 137.5H140C142.485 137.5 144.5 139.515 144.5 142V145.5V146.5V149.5C144.5 152.261 142.261 154.5 139.5 154.5H116C113.515 154.5 111.5 152.485 111.5 150C111.5 147.515 113.515 145.5 116 145.5H131.5C133.709 145.5 135.5 143.709 135.5 141.5Z",
    fill: "#9CA3AF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/qr.230f1925.svg";
export { ForwardRef as ReactComponent };